class UserModel {
  static isSafeProduct(ingredientsList, categories, userAllergens) {
    const lowerCaseIngredients = ingredientsList.toLowerCase();
    const lowerCaseCategories = categories.toLowerCase();
    const detectedAllergens = [];

    userAllergens.forEach(allergen => {
      const allergenName = allergen.en.toLowerCase();
      const allergenDetectedInIngredients = lowerCaseIngredients.includes(allergenName);
      const allergenDetectedInCategories = lowerCaseCategories.includes(allergenName);

      if (allergenDetectedInIngredients || allergenDetectedInCategories) {
        detectedAllergens.push(allergen);
      }
    });

    const isSafe = detectedAllergens.length === 0;

    return {
      isSafe,
      detectedAllergens,
    };
  }
}

export default UserModel;